import { useFirebaseData } from './useFirebaseData';

/**
 * Custom hook for managing store data with Firebase
 * This is an alias for useFirebaseData for backward compatibility
 */
export const useDataManager = () => {
  return useFirebaseData();
};
